import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { returnSubmit } from "../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../contexts/Snackbar";

export default function usePutSpecies(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const queryKey = key;

  const submitCallback = async (obj) => {
    setLoading(true);
    mutate(obj);
  };

  function updateKey(key, newData) {
    const updatedEntity = newData;
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData; // If no old data, return as is
      if (Array.isArray(oldData)) {
        return oldData.map((entity) =>
          Number(entity.id) === Number(updatedEntity.id)
            ? updatedEntity
            : entity
        );
      } else {
        return updatedEntity;
      }
    });
  }

  const { mutate } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: (response) => {
      if (response?.data) {
        if (Array.isArray(queryKey)) {
          queryKey.forEach((key) => updateKey(key, response?.data));
        } else {
          updateKey(queryKey, response?.data);
        }
      } else {
        // Fallback
        queryClient.invalidateQueries([queryKey]);
      }

      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
